import { getOwaUrlWithAddedQueryParameters } from './getOwaUrlWithAddedQueryParameters';
import getCalendarPath from './getCalendarPath';
import isCalendarReactEnabled from './util/isCalendarReactEnabled';

export default function getCalendarEventComposeDeepLinkUrl(itemId: string): string {
    if (isCalendarReactEnabled()) {
        return getCalendarPath() + 'deeplink/compose/' + encodeURIComponent(itemId);
    } else {
        let popoutQuerystringProps = {
            viewmodel: 'IComposeCalendarItemViewModelFactory',
            ItemID: encodeURIComponent(itemId),
            ispopout: '1',
        };
        return getOwaUrlWithAddedQueryParameters(popoutQuerystringProps);
    }
}
